module.exports = __webpack_public_path__ + "static/media/who-sends-the-man.8f376794.txt";